import Script from 'next/script';

import { getUrlOrigin } from '@monoimin/utils/helpers';

import {
  companyAddressesDict,
  organizationIMINCyprusJsonLdDict,
  organizationIMINJsonLdDict,
  organizationIMINMaltaJsonLdDict,
} from '@monoimin/intl';
import { Locales } from '@monoimin/sb-types';

const minisitesValues: {
  [k in MinisiteSlug]: typeof organizationIMINCyprusJsonLdDict;
} = {
  'imin-cyprus': organizationIMINCyprusJsonLdDict,
  'imin-malta': organizationIMINMaltaJsonLdDict,
  'imin-portugal': organizationIMINCyprusJsonLdDict,
  iminproperty: organizationIMINCyprusJsonLdDict,
  'imin-caribbean': organizationIMINCyprusJsonLdDict,
  'imigrant-hungary': organizationIMINCyprusJsonLdDict,
  'immigrant-austria': organizationIMINCyprusJsonLdDict,
};
export const OrganizationIMINJsonLd = ({
  locale,
  site,
}: {
  locale: Locales;
  site?: MiniSlug;
}) => {
  if (!locale) {
    locale = 'en';
  }

  const dict = {
    ...organizationIMINJsonLdDict[locale],
    ...(site
      ? minisitesValues[site as keyof typeof minisitesValues]?.[locale]
      : {}),
  };
  const schema = {
    '@context': 'https://schema.org/',
    '@type': ['LegalService', 'Organization'],
    name: 'Immigrant Invest',
    legalName: 'I.I.I. IMMIGRANT INTEGRATION & INVEST GmbH',
    description: dict.organizationKnowsAbout,
    foundingDate: '2006',
    slogan: dict.organizationSlogan,
    url: dict.mainSiteUrl,
    hasCredential: {
      '@type': 'EducationalOccupationalCredential',
      credentialCategory: 'ProfessionalMembership',
      recognizedBy: {
        '@type': 'Organization',
        name: 'Investment Migration Council',
      },
    },
    areaServed: {
      '@type': 'Place',
      name: 'Worldwide',
    },
    sameAs: [
      dict.organizationFacebook,
      dict.organizationTwitter,
      dict.organizationInstagram,
      'https://www.linkedin.com/company/immigrantinvest',
      'https://www.youtube.com/channel/UCrAe3MNAHRdWexW7k412cMg',
    ],
    logo: {
      '@type': 'ImageObject',
      url: `${getUrlOrigin(undefined, site)}/logo.svg`,
    },
    contactPoint: [
      {
        '@type': 'ContactPoint',
        telephone: '+43 670 308 21 75',
        contactType: 'Press inquiries',
        areaServed: 'Worldwide',
      },
      {
        '@type': 'ContactPoint',
        telephone: '+43 650 540 49 79',
        contactType: 'Partnership inquiries',
        areaServed: 'Worldwide',
      },
    ],
    memberOf: {
      '@type': 'Organization',
      name: 'Investment Migration Council, IMC',
    },
    address: companyAddressesDict[locale],
  };

  return (
    <Script id='organization-jsonld' type='application/ld+json'>
      {JSON.stringify(schema)}
    </Script>
  );
};

export default OrganizationIMINJsonLd;
